import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../../core/login.service';
import { LoginPostBindingModel } from '../../shared/model/login-post-binding';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  user_id: any;
  password: any;
  showRegister: boolean = false;
  showError: boolean = false;
  reTypePasswordValue:string = "";
  hidePassword = true;
  hideReTypePassword = true;
  is_password_suggestion_message: boolean = false;
  is_password_suggestion_number: boolean = false;
  is_password_suggestion_special_character: boolean = false;
  is_password_suggestion_alphabet: boolean = false;
  is_confirm_password_not_match: string = '';

  constructor(private _router: Router, private _loginService: LoginService, private _toastr: ToastrService) { }

  onHandlePasswordFocus() {
    this.is_password_suggestion_message = true;
  }

  onHandlePasswordBlur() {
    this.is_password_suggestion_message = false;
  }

  ngOnInit(): void {
    this._loginService.refreshToken().subscribe((data: any) => {
      if (data?.data) {
        localStorage.setItem('role', data.data.role);
        localStorage.setItem('username', data.data.username);
      }
      // this._router.navigate(['/dashboard/reports'], { queryParams: { 'summary_type': 'vehicle_summary' } });
      this._router.navigate(['dashboard/home'])
    })
  }

  //#region Public methods
  login(user_id: string, password: string) {
    const model: LoginPostBindingModel = {
      user_id: user_id.trim(),
      password: password.trim(),
      version: 'v4'
    }
    this._loginService.login(model).subscribe((result: any) => {
      localStorage.setItem('role', result.data.role);
      localStorage.setItem('username', result.data.username);
      this._router.navigate(['/dashboard/home']);
    },(err) => {
      this.showToaster(err.message)
    })
  }

  private showToaster(message: string) {
    this._toastr.error(message);
  }

  onRegister(){
    this.showRegister = !this.showRegister;
    if(!this.showRegister){
      this.showError = false;
      this.reTypePasswordValue = "";
    }
  }

  register(user_id:any, password:any){
    if (password !== this.reTypePasswordValue) {
      this.showError = true;
      return;
    }
    this._loginService.register(user_id, password).subscribe((data) => {
      this._toastr.success("User successfully registered");
      this.showRegister = false;
    },(err) => {
      this._toastr.error(err.error);
    })
  }

  matchPassword(event:any){  
    this.reTypePasswordValue = event;
    this.showError = !(event === this.password);
    this.is_confirm_password_not_match = this.showError ? "Passwords don't match. Re-Enter passwords." : '';
  }

  onPasswordChange(password: string) {
    this.is_password_suggestion_number = /[0-9]/.test(password);
    this.is_password_suggestion_special_character = /[!@#$%^&*(),.?":{}|<>]/.test(password);
    this.is_password_suggestion_alphabet = /[a-zA-Z]/.test(password);
  }

  //#endregion

}
